import { variables } from 'components/theme/variables';
// import { ReactComponent as ArrowUp } from 'assets/icons/arrow_upwards.svg';

export const customStyles = {
  container: provided => ({
    ...provided,
    marginBottom: '14px',
    '&:hover': {
      cursor: 'pointer'
    }
  }),

  control: provided => ({
    ...provided,
    borderRadius: '8px;',
    border: '0.9px solid #707070',
    boxShadow: '0 !important',
    '&:hover': {
      border: '0.5px solid #707070',
      cursor: 'pointer'
    },
    height: '43px'
  }),

  menu: provided => ({
    ...provided,
    zIndex: 999
  }),

  option: (provided, state) => ({
    ...provided,
    color: `${variables.colors.grey4}`,
    backgroundColor: state.isFocused ? '#F6F6F6' : '#fff',
    cursor: 'pointer',
    fontWeight: '600'
  }),

  IndicatorSeparator: provided => ({ ...provided, display: 'none' }),

  singleValue: (provided, state) => {
    const opacity = state.isDisabled ? 0.5 : 1;
    const transition = 'opacity 300ms';
    const fontWeight = '600';

    return { ...provided, opacity, transition, fontWeight };
  },

  placeholder: provided => ({
    ...provided,
    fontWeight: `${variables.fonts.overpassMonoRegular.fontWeight}`
  })

  // dropdownIndicator: provided => ({
  //   ...provided,
  //   display: 'none',
  //   transition: 'all .4s ease',
  // }),

  // dropdownIndicator: (provided, props) => ({
  //   ...provided,
  //   transition: 'all .4s ease',
  //   transform: props.selectProps.menuIsOpen ? 'rotate(180deg)' : null,
  //   transformOrigin: props.selectProps.menuIsOpen ? 'center' : null
  // })
};
